import { Box } from '@bechtel/gds';
import { TimesheetStatus } from '@bechtel/types';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

interface NavLinkStyledProps {
  isDisable: boolean;
}

export const NavLinkStyled = styled(NavLink)<NavLinkStyledProps>`
  ${({ theme, isDisable }) => css`
    background-color: ${theme.colors.white};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    transition-timing-function: ease-in-out;
    transition-duration: 80ms;
    transition-property: background-color;
    ${isDisable &&
    css`
      pointer-events: none;
      opacity: 0.5;
      cursor: pointer;
    `};
    ${!isDisable &&
    css`
      &:active,
      &.active,
      &:hover {
        background-color: ${theme.colors.bechtel.blue[100]};
      }
    `};
  `}
`;

interface CrewTimesheetIndicatorStyledProps {
  status: TimesheetStatus;
}

function getCrewTimesheetIndicatorStyles({ status }: CrewTimesheetIndicatorStyledProps) {
  switch (status) {
    case TimesheetStatus.IN_PROGRESS || TimesheetStatus.NOT_STARTED:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
      `;
    case TimesheetStatus.APPROVED || TimesheetStatus.SUBMITTED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
      `;
  }
}

export const CrewTimesheetIndicatorStyled = styled(Box).attrs({ mr: { sm: '400' } })<CrewTimesheetIndicatorStyledProps>`
  ${({ theme }) => css`
    width: ${theme.spacings[400]};
    height: ${theme.spacings[800]};
  `}
  ${getCrewTimesheetIndicatorStyles};
`;
